import AbstractRepository from "@/repositories/AbstractRepository";

export default class ListSfPlaceRepository extends AbstractRepository {
    protected static resource: string = "ptf-monocle-listdefinition-place";

    protected static defaultFields: string[] = [
        "uuid",
        "label",
    ];
}
